import React from "react";
import PropTypes from "prop-types";
import "./SentimentPill.scss";

const SentimentPill = ({ sentiment }) => {
  const normalizedSentiment = sentiment?.toLowerCase() || "neutral";

  return (
    <div className={`sentiment-pill sentiment-pill-${normalizedSentiment}`}>
      <span className="sentiment-pill-text">
        {sentiment.charAt(0).toUpperCase() + sentiment.slice(1)}
      </span>
    </div>
  );
};

SentimentPill.propTypes = {
  sentiment: PropTypes.oneOf([
    "bullish",
    "neutral",
    "bearish",
    "Bullish",
    "Neutral",
    "Bearish",
  ]).isRequired,
};

export default SentimentPill;
